import { pushRetryableEvent } from "./utils";

export default PwaInstallHook = {
    mounted() {
        this.deferredPrompt = null;

        window.addEventListener("beforeinstallprompt", (e) => {
            e.preventDefault();
            this.deferredPrompt = e;
            pushRetryableEvent(this, "pwa_install_available");
        });

        this.handleEvent("trigger_pwa_install", () => {
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
            
            if (isIOS && !isStandalone) {
                pushRetryableEvent(this, "pwa_install_not_available");
            } else if (this.deferredPrompt) {
                this.deferredPrompt.prompt();
                this.deferredPrompt.userChoice.then((choiceResult) => {
                    if (choiceResult.outcome === "accepted") {
                        pushRetryableEvent(this, "pwa_install_accepted");
                    } else {
                        pushRetryableEvent(this, "pwa_install_dismissed");
                    }
                    this.deferredPrompt = null;
                });
            } else {
                pushRetryableEvent(this, "pwa_install_not_available");
            }
        });
    },
};
